import React from "react";
import { BRANDS } from "../mock";

const BrandsBar = () => {
  return (
    <section className="bg-white border-y border-neutral-200 py-10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#0b2960]">Les grandes marques</h2>
          <p className="text-neutral-600 mt-1 text-sm">Toutes les meilleures marques d'électroménager en stock</p>
        </div>

        <div className="overflow-hidden relative">
          <div className="flex items-center gap-8 md:gap-14 animate-marquee whitespace-nowrap">
            {[...BRANDS, ...BRANDS].map((brand, i) => (
              <div
                key={`${brand}-${i}`}
                className="shrink-0 text-2xl md:text-3xl font-black tracking-tight text-neutral-400 hover:text-[#0b2960] transition-colors"
              >
                {brand}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsBar;
